module.exports = __webpack_public_path__ + "img/case18-上海.f7563a61.png";